import React from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { ICustomerAnalyticsFilters } from "../../models/admin/customerAnalytics/customerAnalytics";
import { CustomerAnalyticsStyles } from "./CustomerAnalyticsStyles";
import StatusDropdown from "./StatusDropdown";
import LOBDropdown from "./LOBDropdown";

interface ICustomerAnalyticsFiltersProps {
  filters: ICustomerAnalyticsFilters;
  handleDateChange: (type: "from" | "to", value: string) => void;
  onStatusChange: (status: string) => void;
  selectedAnalyticsType: number;
  selectedLOB: string;
  onLOBChange: (lob: string) => void;
}

const CustomerAnalyticsFilters: React.FC<ICustomerAnalyticsFiltersProps> = ({
  filters,
  handleDateChange,
  onStatusChange,
  selectedAnalyticsType,
  selectedLOB,
  onLOBChange,
}) => {
  const isMobile = useMediaQuery("(max-width:767px)");

  const todayDate = new Date().toISOString().split("T")[0];

  const formatDate = (date: string | Date | undefined) => {
    if (!date) return "";
    if (typeof date === "string") {
      return date.split("T")[0];
    }
    if (date instanceof Date) {
      return date.toISOString().split("T")[0];
    }
    return "";
  };

  const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;

    if (!selectedDate) {
      handleDateChange("to", "");
      return;
    }

    const date = new Date(selectedDate);
    date.setHours(23, 59, 59, 999);

    const adjustedDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    );
    const formattedDateTime = adjustedDate.toISOString();
    handleDateChange("to", formattedDateTime);
  };

  return (
    <Card sx={CustomerAnalyticsStyles.filtersCard}>
      <CardContent sx={CustomerAnalyticsStyles.filtersCardContent}>
        <Box sx={{...CustomerAnalyticsStyles.filtersCardTopContent, marginBottom:'1.25rem'}}>
          <Box sx={CustomerAnalyticsStyles.dateFieldsContianer}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <TextField
                size="small"
                fullWidth
                type="date"
                label="From"
                value={formatDate(filters.fromDate)}
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  handleDateChange("from", selectedDate);
                }}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  max: todayDate,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <TextField
                size="small"
                fullWidth
                type="date"
                label="To"
                value={formatDate(filters.toDate)}
                onChange={handleToDateChange}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  max: todayDate,
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{...CustomerAnalyticsStyles.filtersCardTopContent, justifyContent:selectedAnalyticsType === 1 ? 'space-between' :'flex-end'}}>
          {selectedAnalyticsType === 1 && (
            <LOBDropdown selectedLOB={selectedLOB} onLOBChange={onLOBChange} />
          )}
          <StatusDropdown onStatusChange={onStatusChange} />
      </Box>
      </CardContent>
    </Card>
      
  );
};
export default CustomerAnalyticsFilters;
